import React from 'react';

function UnderlineIcon({ className }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="currentColor">
            <rect width="30" height="30" fill="none"/>
            <path d="M9.5 21H20.224V21.7H9.5V21Z"/>
            <path d="M11.9361 16.17C11.9361 16.59 12.0155 16.954 12.1741 17.262C12.3328 17.5607 12.5475 17.8033 12.8181 17.99C13.0888 18.1767 13.3968 18.3167 13.7421 18.41C14.0968 18.494 14.4701 18.536 14.8621 18.536C15.2541 18.536 15.6228 18.494 15.9681 18.41C16.3228 18.3167 16.6355 18.1767 16.9061 17.99C17.1768 17.794 17.3915 17.5467 17.5501 17.248C17.7088 16.9493 17.7881 16.59 17.7881 16.17V9.8H19.1041V16.24C19.1041 16.8373 18.9921 17.3553 18.7681 17.794C18.5441 18.2327 18.2361 18.5967 17.8441 18.886C17.4615 19.1753 17.0135 19.39 16.5001 19.53C15.9868 19.67 15.4408 19.74 14.8621 19.74C14.2835 19.74 13.7328 19.67 13.2101 19.53C12.6968 19.39 12.2488 19.1753 11.8661 18.886C11.4835 18.5967 11.1801 18.2327 10.9561 17.794C10.7321 17.3553 10.6201 16.8373 10.6201 16.24V9.8H11.9361V16.17Z"/>
        </svg>
    );
}

export default UnderlineIcon;
